"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubAppHybProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const SubAppHybProviders = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.HashRouter, { children: children });
};
exports.SubAppHybProviders = SubAppHybProviders;
//# sourceMappingURL=providers.js.map